import React, { useEffect, useState } from 'react'
import { Card, Modal } from 'react-bootstrap'
import ListaDocumentos from './ListaDocumentos'
import AnexarGeral from './AnexarGeral'
import PageLoading from '../../Common/PageLoading'
import anexosService from '../../../services/anexos.service'

export default function TabDocumentos({ pacienteId, planosOrtodontia, planosTratamento }) {
  const [isLoading, setIsLoading] = useState(false)

  const [abrirModal, setAbrirModal] = useState(false)
  const [abrirModalAnexarGeral, setAbrirModalAnexarGeral] = useState(false)
  const [abrirModalAnexarTratamento, setAbrirModalAnexarTratamento] = useState(false)

  const [documentos, setDocumentos] = useState([])
  const [tratamentos, setTratamentos] = useState([])
  const [tratamento, setTratamento] = useState({})

  const [categorias, setCategorias] = useState([])

  useEffect(() => {
    initialize()
  }, [planosOrtodontia, planosTratamento])

  const initialize = async () => {
    const responseCategorias = await anexosService.getCategorias()
    setCategorias(responseCategorias.data)

    const responseDocumentos = await anexosService.getDocumentos(pacienteId)
    const documentoGerais = responseDocumentos.data.filter(
      (documento) => documento.planoTratamentoId === null && documento.planoTratamentoOrtodontiaId === null
    )
    const documentosPorTratamento = responseDocumentos.data.filter(
      (documento) => documento.planoTratamentoId !== null || documento.planoTratamentoOrtodontiaId !== null
    )

    setDocumentos(documentoGerais)

    const tratamentosMapped = []

    planosOrtodontia.map((trat) => {
      tratamentosMapped.push({
        planoTratamentoOrtodontiaId: trat.id,
        numeroPlano: trat.numeroPlano,
        pacienteId: trat.pacienteId,
        pacienteNome: trat.paciente?.nome,
        documentos: documentosPorTratamento.filter((documento) => documento.planoTratamentoOrtodontiaId === trat.id),
      })
    })

    planosTratamento.map((trat) => {
      tratamentosMapped.push({
        planoTratamentoId: trat.id,
        numeroPlano: trat.numeroPlano,
        pacienteId: trat.pacienteId,
        pacienteNome: trat.paciente?.nome,
        documentos: documentosPorTratamento.filter((documento) => documento.planoTratamentoId === trat.id),
      })
    })

    setTratamentos(tratamentosMapped)
  }

  const abrirModalComDocumentos = (trat) => {
    setTratamento(trat)
    setAbrirModal(true)
  }

  const fecharModais = async () => {
    setAbrirModalAnexarGeral(false)
    setAbrirModalAnexarTratamento(false)
    setAbrirModal(false)

    setIsLoading(true)
    await initialize()
    setIsLoading(false)
  }

  const download = async (documento) => {
    setIsLoading(true)
    await anexosService.download(documento.id, documento.nomeGerado)
    setIsLoading(false)
  }

  const categoriaNome = (categoriaId) => {
    const c = categorias.find((categoria) => categoria.id == categoriaId)
    return c ? c.nome : '—'
  }

  return (
    <div>
      {isLoading && <PageLoading />}
      <div>
        <div className='mt-3 mb-1 row'>
          <div className='col'>
            <h2 className='h5 border-bottom pb-2'>Documentos por Tratamento(s)</h2>
            <p>Todos anexos centralizados nesta aba, ficha, atestado, contrato assinado, documentos, entre outros.</p>
          </div>
        </div>

        <div className='text-right mb-2'>
          <button
            className='btn btn-outline-primary'
            onClick={() => {
              setTratamento({})
              setAbrirModalAnexarTratamento(true)
            }}
          >
            Anexar no Tratamento
          </button>
        </div>

        <div className='d-none d-md-block'>
          <div
            className='table-responsive plano-tratamento-detalhe-scroll'
            style={{ WebkitOverflowScrolling: 'touch' }}
          >
            <table className='table table-bordered mb-0' style={{ minWidth: '560px' }}>
              <thead>
                <tr>
                  <th>Número do Plano</th>
                  <th>Paciente</th>
                  <th>Qtd de Documentos</th>
                </tr>
              </thead>
              <tbody>
                {tratamentos.map((trat, index) => (
                  <tr key={index} className='cursor-pointer' onClick={() => abrirModalComDocumentos(trat)}>
                    <td>{trat.numeroPlano}</td>
                    <td>{trat.pacienteNome}</td>
                    <td>{trat.documentos.length}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className='d-md-none'>
          {tratamentos.map((trat, index) => (
            <Card
              key={index}
              className='mb-3 shadow-sm border plano-tratamento-card-mobile cursor-pointer'
              onClick={() => abrirModalComDocumentos(trat)}
            >
              <Card.Body className='p-3'>
                <div className='font-weight-bold text-dark mb-2'>Plano {trat.numeroPlano}</div>
                <div className='small'>
                  <div className='d-flex justify-content-between py-2 border-bottom'>
                    <span className='text-muted'>Paciente</span>
                    <span className='text-dark text-right'>{trat.pacienteNome}</span>
                  </div>
                  <div className='d-flex justify-content-between py-2'>
                    <span className='text-muted'>Documentos</span>
                    <span className='badge badge-secondary'>{trat.documentos.length}</span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>

        <div className='mt-3 mb-1 row'>
          <div className='col'>
            <h2 className='h5 border-bottom pb-2'>Documentos Gerais</h2>
            <p>Todos anexos gerais referente ao Paciente diretamente sem vinculo algum com tratamento.</p>
          </div>
        </div>

        <div className='text-right mb-2'>
          <button className='btn btn-outline-primary' onClick={() => setAbrirModalAnexarGeral(true)}>
            Anexar
          </button>
        </div>

        <div className='d-none d-md-block'>
          <div
            className='table-responsive plano-tratamento-detalhe-scroll'
            style={{ WebkitOverflowScrolling: 'touch' }}
          >
            <table className='table table-bordered mb-0' style={{ minWidth: '720px' }}>
              <thead>
                <tr>
                  <th>Identificador</th>
                  <th>Nome do Documento</th>
                  <th>Nome do Sistema</th>
                  <th>Categoria</th>
                </tr>
              </thead>
              <tbody>
                {documentos.map((documento) => (
                  <tr key={documento.id} className='cursor-pointer' onClick={() => download(documento)}>
                    <td>{documento.id}</td>
                    <td>{documento.nome}</td>
                    <td>{documento.nomeGerado}</td>
                    <td>{categoriaNome(documento.categoriaId)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className='d-md-none'>
          {documentos.map((documento) => (
            <Card
              key={documento.id}
              className='mb-3 shadow-sm border plano-tratamento-card-mobile cursor-pointer'
              onClick={() => download(documento)}
            >
              <Card.Body className='p-3 small'>
                <div className='d-flex justify-content-between py-1 border-bottom'>
                  <span className='text-muted'>Identificador</span>
                  <span className='text-dark'>{documento.id}</span>
                </div>
                <div className='d-flex justify-content-between py-1 border-bottom'>
                  <span className='text-muted'>Nome</span>
                  <span className='text-dark text-right'>{documento.nome}</span>
                </div>
                <div className='d-flex justify-content-between py-1 border-bottom'>
                  <span className='text-muted'>Sistema</span>
                  <span className='text-dark text-right small'>{documento.nomeGerado}</span>
                </div>
                <div className='pt-2'>
                  <span className='text-muted d-block mb-1'>Categoria</span>
                  <span className='text-dark'>{categoriaNome(documento.categoriaId)}</span>
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>

        <Modal className='modal-documentos' show={abrirModal} onHide={() => fecharModais()}>
          <Card>
            <Modal.Header className='p-4' closeButton>
              <Modal.Title>{tratamento.numeroPlano}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='p-4'>
              <ListaDocumentos tratamento={tratamento} download={(doc) => download(doc)} categorias={categorias} />
            </Modal.Body>
          </Card>
        </Modal>

        <Modal className='modal-documentos' show={abrirModalAnexarTratamento} onHide={() => fecharModais()}>
          <Card>
            <Modal.Header className='p-4' closeButton>
              <Modal.Title>
                {tratamento?.numeroPlano !== undefined ? (
                  <p>Anexe documento(s) no Tratamento {tratamento.numeroPlano}</p>
                ) : (
                  <p>Selecione um Tratamento</p>
                )}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className='p-4'>
              {tratamento?.numeroPlano === undefined ? (
                <div>
                  <p>Selecione Tratamento para anexar documento(s)</p>
                  <div className='d-none d-md-block'>
                    <div
                      className='table-responsive plano-tratamento-detalhe-scroll'
                      style={{ WebkitOverflowScrolling: 'touch' }}
                    >
                      <table className='table table-bordered mb-0' style={{ minWidth: '400px' }}>
                        <thead>
                          <tr>
                            <th>Número do Plano</th>
                            <th>Paciente</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tratamentos.map((trat, index) => (
                            <tr className='cursor-pointer' key={index} onClick={() => setTratamento(trat)}>
                              <td>{trat.numeroPlano}</td>
                              <td>{trat.pacienteNome}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className='d-md-none'>
                    {tratamentos.map((trat, index) => (
                      <Card
                        key={index}
                        className='mb-2 cursor-pointer plano-tratamento-card-mobile'
                        onClick={() => setTratamento(trat)}
                      >
                        <Card.Body className='p-3 small'>
                          <strong>Plano {trat.numeroPlano}</strong>
                          <div className='text-muted mt-1'>{trat.pacienteNome}</div>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                </div>
              ) : (
                <AnexarGeral
                  fecharModais={fecharModais}
                  pacienteId={pacienteId}
                  categorias={categorias}
                  planoTratamentoId={tratamento.planoTratamentoId}
                  planoTratamentoOrtodontiaId={tratamento.planoTratamentoOrtodontiaId}
                />
              )}
            </Modal.Body>
          </Card>
        </Modal>

        <Modal className='modal-documentos' show={abrirModalAnexarGeral} onHide={() => fecharModais()}>
          <Card>
            <Modal.Header className='p-4' closeButton>
              <Modal.Title>Anexe documento(s) no Paciente</Modal.Title>
            </Modal.Header>
            <Modal.Body className='p-4'>
              <AnexarGeral fecharModais={fecharModais} pacienteId={pacienteId} categorias={categorias} />
            </Modal.Body>
          </Card>
        </Modal>
      </div>
    </div>
  )
}
